<template>
  <v-container>
    <live-payment v-if="!isPaid"></live-payment>
    <v-row v-show="isPaid">
      <v-col cols="12" align="center" justify="center">
        <div id="video_wrapper" class="player-container">
          <!-- Video element will be injected here by Video.js or manually if needed, but cleaner to let Video.js handle the provided element -->
          <video 
            id="player_videojs" 
            class="video-js vjs-default-skin vjs-big-play-centered" 
            controls 
            preload="auto" 
            playsinline
            style="width: 100%; height: 100%;"
          >
          </video>
        </div>
      </v-col>
      <v-col cols="12"><span class="headline font-weight-black">{{channelName}}</span></v-col>
      <v-col cols="12"><span class="subtitle-1 font-weight-black">{{title}}</span></v-col>
      <v-col cols="12"><span class="body-2"> {{description}} </span></v-col>
      <v-col cols="12">
        <v-btn rounded color="#5CDB95" @click="goLive" :disabled="!isLive">
          <v-icon color="red" left>mdi-play</v-icon>Go to live
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-menu
            v-model="dmenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
        >
            <template v-slot:activator="{ on }">
            <v-text-field 
            outlined
            v-model="date"
            label="Select date"
            v-on="on"
            
            readonly
            ></v-text-field>
            </template>
            <v-date-picker v-model="date" :max="max" :min="min" @input="dateSelected"></v-date-picker>
        </v-menu>
      </v-col>
      <!-- <v-col cols="12">
        <pre-payment></pre-payment>
      </v-col> -->
    </v-row>
    <v-row>
      <v-col v-for="item in vlist.slice().reverse()" :key="item.id" cols="12">
        <v-card @click="selectVideo(item)">
            <v-row>
              <v-col cols="8" md="9" lg="10">
                <v-row>
                  <v-col cols="12">
                    <span class="subtitle-1 font-weight-black">{{item.name}}</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="d-none d-sm-flex"> {{item.duration}} </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import LivePayment from '@/components/LivePayment.vue'
  import videojs from 'video.js'
  import 'video.js/dist/video-js.css'
  import 'videojs-contrib-quality-levels'
  import 'videojs-hls-quality-selector'
  import firebase from 'firebase/app'
  import 'firebase/database'

  export default {
    name: 'ChannelLive',
    props: ['channelid'],
    data: () => ({
      title: '',
      description: '',
      vlist: [],
      date: '',
      dmenu: false,
      src: '',
      stream: {},
      valid: true,
      alreadyWatching: false,
      loading: true,
      isPaid: false,
      channelName: '',
      player: null,
      isLive: false,
    }),
    components: {
      LivePayment
    },
    computed: {
    max () {
      let date = new Date
      return date.toISOString()
    },
    min () {
      let date = new Date
      date.setDate(date.getDate() - 365)
      return date.toISOString()
    },
    branch() {
      return this.$store.getters.loadedBranch
    }
  },
  methods: {
    checkPayment() {
      var studentid = this.$store.getters.loadedRoll
      firebase.database().ref('payment/'+this.channelid+'/'+studentid).once('value')
      .then((data) => {
        if(data.val()){
          var payd = data.val()
          var d = new Date()
          var validityCheck = +payd.expires - d.getTime()
          if(payd.status == 'paid' && validityCheck >= 0){
            this.isPaid = true
            this.initiate()
          } else {
            this.isPaid = false
          }
        } else {
          this.isPaid = false
        }
      })
    },
    createPlayer(source) {
        if (this.player) {
            this.player.dispose();
            this.player = null;
        }

        // Reset DOM for video.js
        const wrapper = document.getElementById('video_wrapper');
        if (wrapper) {
            wrapper.innerHTML = `
            <video 
                id="player_videojs" 
                class="video-js vjs-default-skin vjs-big-play-centered" 
                controls 
                playsinline
                style="width: 100%; height: 100%;"
            >
            </video>
            <div id="seek_overlay_rewind" class="seek-overlay left-overlay" style="display:none;">
                <div class="d-flex flex-column align-center justify-center white--text">
                   <i class="v-icon mdi mdi-rewind" style="font-size: 48px; color: white;"></i>
                   <span class="font-weight-bold" style="font-size: 20px;">-5s</span>
                </div>
            </div>
             <div id="seek_overlay_forward" class="seek-overlay right-overlay" style="display:none;">
                <div class="d-flex flex-column align-center justify-center white--text">
                   <i class="v-icon mdi mdi-fast-forward" style="font-size: 48px; color: white;"></i>
                   <span class="font-weight-bold" style="font-size: 20px;">+5s</span>
                </div>
            </div>`;
        }

        this.$nextTick(() => {
            this.player = videojs('player_videojs', {
                autoplay: true,
                controls: true,
                liveui: true,
                responsive: true,
                nativeControlsForTouch: false, 
                customControlsOnMobile: true,
                breakpoints: {
                    tiny: 300,
                    xsmall: 400,
                    small: 500,
                    medium: 600,
                    large: 800,
                    xlarge: 1000,
                    huge: 1200
                },
                playbackRates: [0.5, 1, 1.5, 2],
                controlBar: {
                    children: [
                        'playToggle',
                        'volumePanel',
                        'currentTimeDisplay',
                        'timeDivider',
                        'durationDisplay',
                        'progressControl',
                        'liveDisplay',
                        'remainingTimeDisplay',
                        'customControlSpacer',
                        'playbackRateMenuButton',
                        'qualitySelector',
                        'fullscreenToggle'
                    ]
                },
                sources: [{
                    src: source,
                    type: 'application/x-mpegURL'
                }],
                fluid: true, // makes it responsive
                html5: {
                    vhs: {
                        overrideNative: true,
                        enableLowInitialPlaylist: true,
                        smoothQualityChange: true,
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false
                }
            });

            // Initialize Quality Selector Plugin
            this.player.hlsQualitySelector({
                displayCurrentQuality: true,
            });
            
            // Double Tap Logic
            let lastTap = 0;
            let tapTimeout;
            const videoElement = this.player.el();
            const rewindOverlay = document.getElementById('seek_overlay_rewind');
            const forwardOverlay = document.getElementById('seek_overlay_forward');

            videoElement.addEventListener('touchend', (event) => {
                // Ignore taps on control bar
                if (event.target.closest('.vjs-control-bar')) return;

                const currentTime = new Date().getTime();
                const tapLength = currentTime - lastTap;

                clearTimeout(tapTimeout);

                if (tapLength < 300 && tapLength > 0) {
                    event.preventDefault();
                    // Double tap
                    const rect = videoElement.getBoundingClientRect();
                    const tapX = event.changedTouches[0].clientX - rect.left;
                    const width = rect.width;
                    
                    let overlay = null;

                    if (tapX < width / 2) {
                        // Rewind
                        let newTime = Math.max(0, this.player.currentTime() - 5);
                        this.player.currentTime(newTime);
                        overlay = rewindOverlay;
                    } else {
                        // Forward
                        let newTime = Math.min(this.player.duration(), this.player.currentTime() + 5);
                        this.player.currentTime(newTime);
                        overlay = forwardOverlay;
                    }

                    if (overlay) {
                        overlay.style.display = 'flex';
                        // Add simple animation class if needed, or just timeout
                        setTimeout(() => {
                            overlay.style.display = 'none';
                        }, 500);
                    }

                    lastTap = 0;
                } else {
                    lastTap = currentTime;
                    tapTimeout = setTimeout(() => {
                        lastTap = 0;
                    }, 300);
                }
            });

            this.loading = false;
        });
    },
    selectVideo (item) {
      this.title = item.name;
      this.description = item.description;
      this.createPlayer(item.link);
    },
    goLive () {
      this.title = '';
      this.description = '';
      this.createPlayer(this.src);
    },
    initiate () {
      firebase.database().ref('channels/'+ this.channelid).on('value', (data) => {
        var channelData = data.val()
        if(channelData) {
            this.channelName = channelData.name
            var src = channelData.hls
            this.src = "https://nr-api.tharainfotech.com"+src
            
            if (channelData.live) {
                this.isLive = true
                // Auto-play only if player isn't already created or if we want to force switch to live
                // For now, let's just ensure we don't interrupt if they are watching VOD, 
                // unless this is initial load.
                // But requirement says "auto initiate only when ... true".
                // So if no player exists, create it.
                if (!this.player) {
                     this.createPlayer(this.src);
                }
            } else {
                this.isLive = false
                // Optional: stop player if live ends?
                // For now, leaving as is unless requested.
            }
        }
      })
    },
    dateSelected () {
      this.vlist = []
      this.dmenu = false
      var date = new Date(this.date)
      var y = +date.getYear() - 100
      var m = +date.getMonth() + 1
      var d = date.getDate()
      if(m < 10) {
        m = '0' + m
      } 
      if(d < 10) {
        d = '0' + d
      } 
      var val = d.toString()+m.toString()+y.toString()
      firebase.database().ref('vod/'+this.channelid+'/'+val).once('value')
      .then((data) => {
        var list = data.val()
        if(list) {
          for(let i in list) {
            let link = list[i].link;
            if (link && !link.endsWith('.m3u8')) {
                link = `https://nrvod.ap-south-1.linodeobjects.com/${link}/file.m3u8`;
            }
            var item = {
              id: i,
              name: list[i].name,
              link: link,
              duration: list[i].duration ? new Date(+list[i].duration * 1000).toISOString().substr(11, 8) : '',
              description: list[i].description
            }
            this.vlist.push(item) 
          }
        }
      })
      //this.selectVideo()
    },
  },
  mounted () {
    this.checkPayment()
  },
  beforeDestroy() {
    if (this.player) {
        this.player.dispose();
    }
  }
  }
</script>

<style scoped>
  .player-container {
    width: 100%;
    /* maintain aspect ratio or fixed height? Original was 300px fixed height. */
    /* Video.js fluid:true handles aspect ratio, but if container is small... */
    /* Let's keep min-height to be safe */
    min-height: 300px; 
    position: relative;
  }
  .seek-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.4);
    pointer-events: none;
  }
  .left-overlay {
    left: 0;
  }
  .right-overlay {
    right: 0;
  }
  ::v-deep .video-js .vjs-playback-rate {
    display: flex !important;
  }
  /* video.js override if needed */
</style>
